import { systemRights, } from "@tedivo/tvd-api-models";
import { ListComponentWithActions } from "../../common/ListComponentWithActions";
import Services from "../../../app/services";
import { createTableUserStorageInstance } from "../../../app/preferences/createTableUserStorageInstance";
import { formatDateInCurrentTimezone } from "@tedivo/tedivo-pure-helpers";
import { getTranslation } from "../../../app/i18/i18tn";
import goSquared from "../../../app/tracking/goSquared";
import { routeFns } from "../../../app/router/routes";
import router from "../../../app/router";
import { setAppTitle } from "../../../app/setAppTitle";
export class TVDAdminUsersComponent extends ListComponentWithActions {
    constructor() {
        super();
        this.exportToExcelFn = () => {
            var _a;
            const usersData = (_a = this.smartTable) === null || _a === void 0 ? void 0 : _a.sortedData;
            if (!usersData)
                return;
            this.exportButton.loading = true;
            this.exportButton.disabled = true;
            import(/* webpackChunkName: "exportUsersToExcel" */ "./exportUsersToExcel")
                .then((module) => {
                module.exportUsersToExcel(usersData);
            })
                .finally(() => {
                this.exportButton.loading = false;
                this.exportButton.disabled = false;
            });
        };
        this.h1Label = "general:users.users";
        this.goSquaredLabel = "Admin/Users";
        this.topLabel = "general:adminArea";
        this.deleteLabel = "general:users.delete";
        this.serviceListCall = Services.organizations.adminGetAllUsers;
        this.systemRightToEdit = systemRights.ORG.AppAdminCrudOrganizationUser;
        const userOptionsStorage = createTableUserStorageInstance("adminUsersList");
        const exportButton = document.createElement("sl-button");
        exportButton.className = "tvd-button";
        exportButton.innerHTML = getTranslation("general:common.exportToXlsx");
        exportButton.variant = "primary";
        exportButton.addEventListener("click", () => {
            this.exportToExcelFn();
        });
        this.exportButton = exportButton;
        this.tableConfig = (data) => createUsersTableConfig(data, userOptionsStorage, exportButton);
        setAppTitle(getTranslation("general:users.users"));
        goSquared.trackPage("TEDIVO Admin Pages - Users");
    }
}
TVDAdminUsersComponent.observedAttributes = [];
customElements.define("tvd-admin-users-component", TVDAdminUsersComponent);
function createUsersTableConfig(usersData, userOptionsStorage, exportButton) {
    const actionBox = document.createElement("div");
    actionBox.appendChild(exportButton);
    const tableConfig = {
        title: getTranslation("general:users.adminList"),
        className: "tvd-table tvd-table-smart-table",
        data: usersData,
        defaultSortBy: "name",
        fields: [
            {
                name: "name",
                label: getTranslation("general:common.name"),
            },
            {
                name: "familyName",
                label: getTranslation("general:users.familyName"),
            },
            {
                name: "email",
                label: getTranslation("general:common.email"),
            },
            {
                name: "organizations",
                label: getTranslation("general:organizations.organizations"),
                sortValueFunction: (dta) => dta.organizations
                    .map((o) => o.name)
                    .sort()
                    .join(","),
                mapper: (dta) => {
                    return createOrgsNode(dta);
                },
            },
            {
                name: "userStatusType",
                label: getTranslation("general:common.status"),
                mapper: (u) => getTranslation(`enums:UserStatusType.${u.userStatusType}`),
                className: (u) => (u === null || u === void 0 ? void 0 : u.userStatusType) === "EXTERNAL_PROVIDER" ? "state-highlighted" : "",
            },
            {
                name: "userCreateDate",
                label: getTranslation("general:common.createdAt"),
                valueFunction: (dta) => dta.userCreateDate
                    ? formatDateInCurrentTimezone(dta.userCreateDate)
                    : "",
                className: "centered",
            },
            {
                name: "userLastModifiedDate",
                label: getTranslation("general:common.modifiedAt"),
                valueFunction: (dta) => dta.userLastModifiedDate
                    ? formatDateInCurrentTimezone(dta.userLastModifiedDate)
                    : "",
                className: "centered",
            },
            {
                name: "lastLoginDate",
                label: getTranslation("general:users.lastLoginDate"),
                valueFunction: (dta) => dta.lastLoginDate
                    ? formatDateInCurrentTimezone(dta.lastLoginDate)
                    : "",
                className: "centered",
            },
        ],
        settings: {
            sortEnabled: true,
            sortVisible: true,
            userOptionsStorage,
            filters: {
                textFieldEnabled: true,
                textFieldFilterFields: ["name", "familyName", "organizations"],
                initialTextFieldFilter: userOptionsStorage.retrieveFilterText(),
            },
            labelSortBy: getTranslation("general:common.sortBy"),
            labelSearch: getTranslation("general:common.filterBy"),
            actionBox,
        },
        pkFunction: (dta) => dta.sub,
    };
    return tableConfig;
}
function createOrgsNode(dta) {
    const div = document.createElement("div");
    const orgs = dta.organizations;
    if (!orgs)
        return div;
    orgs
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((r) => {
        const h = document.createElement("div");
        h.className = "parent-orgs-row";
        const span = document.createElement("span");
        span.innerHTML = r.name;
        if (!r.uEnabled)
            span.classList.add("disabled");
        const small = document.createElement("small");
        small.innerHTML = r.role;
        span.appendChild(document.createTextNode(" "));
        span.appendChild(small);
        const editOrgIcon = document.createElement("sl-icon-button");
        editOrgIcon.name = "pencil";
        editOrgIcon.title = `Edit ${r.name}`;
        editOrgIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminOrganizations(), {
                organizationId: r.orgId,
                returnUrl: routeFns.adminUsers(),
            });
        });
        const initials = (dta.name[0] || "").toUpperCase() +
            (dta.familyName[0] || "").toUpperCase();
        const editUsersIcon = document.createElement("sl-icon-button");
        editUsersIcon.name = "person-gear";
        editUsersIcon.title = `Edit ${initials} in ${r.name}`;
        editUsersIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminOrganizationUsers(r.orgId), {
                userMainIdentity: dta.mainIdentityId,
                returnUrl: routeFns.adminUsers(),
            });
        });
        const goToPeoplePageIcon = document.createElement("sl-icon-button");
        goToPeoplePageIcon.name = "people";
        goToPeoplePageIcon.title = `Go to ${r.name} people page`;
        goToPeoplePageIcon.addEventListener("click", () => {
            router.navigate(routeFns.adminOrganizationUsers(r.orgId), {
                returnUrl: routeFns.adminUsers(),
            });
        });
        h.appendChild(span);
        h.appendChild(editOrgIcon);
        h.appendChild(editUsersIcon);
        h.appendChild(goToPeoplePageIcon);
        div.appendChild(h);
    });
    return div;
}
